import React, { ReactNode } from 'react';
import { notification } from 'antd';
import ListEditItem from './ListEditItem';
import LinkToGoogleMap from './LinkToGoogleMap';

interface Props {
  label: ReactNode;
  position?: string;
  extra?: ReactNode;
  style?: any;
  testid?: string;
}

const copyToClipboard = (text: string) => {
  const el = document.createElement('textarea');
  el.value = text;
  document.body.appendChild(el);
  el.focus();
  el.select();
  try {
    document.execCommand('copy');
    document.body.removeChild(el);
    notification.success({
      message: 'Location Copied',
      style: {
        whiteSpace: 'pre',
      },
    });
  } catch (err) {
    console.log('Oops, unable to copy');
  }
};

const LocationListItem: React.FC<Props> = ({
  label,
  position,
  extra,
  style,
  testid,
}) => (
  <ListEditItem
    testid={testid}
    label={label}
    style={style}
    leftItem={<LinkToGoogleMap position={position} />}
    rightItem={
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {extra}
        {position && (
          <img
            src="/images/car-editor/location.svg"
            alt="copy location"
            onClick={() => copyToClipboard(position)}
            style={{ cursor: 'pointer' }}
          />
        )}
      </div>
    }
  />
);

export default LocationListItem;
